import { PageSectionsContentSectionContentBlocks } from '@/tina/__generated__/types';
import { Faqs } from './Faqs';
import { FullWidthImage } from './FullWidthImage';
import { InfoCardList } from './InfoCardList';
import { PriceList } from './PriceTiers';
import { ReviewsList } from './ReviewList';
import { ShippingInformation } from './ShippingInformation';
import { SolutionList } from './SolutionsList';
import { StaffBioCardsList } from './StaffBioCards';
import { StatBar } from './StatBar';
import { VideoTestimonialList } from './TestimonialList';
export interface ContentBlocksProps {
  data: PageSectionsContentSectionContentBlocks[];
}
export function ContentBlocks({
  data
}: ContentBlocksProps) {
  return data ? data.map((block, i) => {
    const key = `${i}-${block.__typename}`;
    switch (block.__typename) {
      case 'PageSectionsContentSectionContentBlocksImageInformationCardList':
        return <InfoCardList data={block} key={key} />;
      case 'PageSectionsContentSectionContentBlocksVideoTestimonials':
        return <VideoTestimonialList data={block.testimonial} key={key} />;
      case 'PageSectionsContentSectionContentBlocksTestimonialCards':
        return <ReviewsList data={block.testimonial} key={key} />;
      case 'PageSectionsContentSectionContentBlocksSolutionCards':
        return <SolutionList data={block.solution} key={key} />;
      case 'PageSectionsContentSectionContentBlocksFullWidthImage':
        return <FullWidthImage data={block} key={key} />;
      case 'PageSectionsContentSectionContentBlocksStatBar':
        return <StatBar data={block} key={key} />;
      case 'PageSectionsContentSectionContentBlocksFaqs':
        return <Faqs data={block} key={key} />;
      case 'PageSectionsContentSectionContentBlocksPricingCards':
        return <PriceList data={block} key={key} />;
      case 'PageSectionsContentSectionContentBlocksStaffBioList':
        return <StaffBioCardsList data={block} key={key} />;
      case 'PageSectionsContentSectionContentBlocksShipping':
        return <ShippingInformation data={block} key={key} />;
      default:
        return null;
    }
  }) : null;
}